import React from "react";
import "../events/EventForm.css";
import { MENSAJE_SENAS_BLOQUEADAS } from "../../helpers/senasOrganizer";

// Se usa <a> y no <Link> para no exigir un Router en los formularios que lo montan.
const AvisoSenasBloqueadas = () => (
  <div className="ef-alert ef-alert--info" role="status" style={{ marginBottom: 16 }}>
    {MENSAJE_SENAS_BLOQUEADAS}{" "}
    <a
      href="/organizer/payments"
      style={{ color: "inherit", textDecoration: "underline", fontWeight: 700 }}
    >
      Completar validación de pagos
    </a>
  </div>
);

export default AvisoSenasBloqueadas;
